'use strict';

module.exports = /* @ngInject */ function ($scope, $attrs, $http, apiConfig, parkedInvoiceService) {
	var apiUrl = apiConfig.$get().apiUrl;
	var accessToken = apiConfig.$get().accessToken;

	$scope.hasParkedInvoice = false;

	$scope.parkedInvoices = [];

	/**
	 * Initialise variable after save page loaded
	 * @param orderId
	 */
	$scope.initByOrder = function (orderId) {
		$scope.loadParkedInvoicesByOrderId(orderId);
	};

	/**
	 * load parked invoice result from api by Order Id
	 * @param orderId
	 */
	$scope.loadParkedInvoicesByOrderId = function (orderId) {
		parkedInvoiceService.findByOrderId(orderId).then((parkedInvoices) => {
			$scope.hasParkedInvoice = parkedInvoices?.length > 0;
			$scope.parkedInvoices = parkedInvoices;
			$scope.$apply();
		}, (error) => {
			$scope.parkedInvoices = [];
			console.error(error);
			$scope.hasParkedInvoice = false;
		})
	};

	/**
	 * Filling data from already created parked invoice to invoice.
	 * Main business logic is located here
	 */
	$scope.fillData = function (formId) {
		if ($scope.parkedInvoices.length === 1) {
			try {
				var invoice = $scope.parkedInvoices[0];

				document.querySelector('input[name=TMP_INVOICE_NO]').value = invoice.invoiceNumber;
				document.querySelector('input[name=VS_INVOICE_NO]').value = invoice.invoiceNumber;
				// We don't have next fields in parked invoice
				// document.querySelector('input[name=TMP_INVOICE_MAP]').value = "987654321";
				// document.querySelector('input[name=VS_INVOICE_REMARK]').value = "miep miep";

				// Invoice data - Super stupid, but I can't find another workaround
				const formattedInvoiceDate = moment(invoice.invoiceDate).isValid() ?
					moment(invoice.invoiceDate).format(DATE_FORMAT_LL) : '';
				document.querySelector('input[name=date]').value = formattedInvoiceDate
				var dates = document.querySelectorAll('input[id^=date]');
				dates[0].value = formattedInvoiceDate

				if (invoice.comment != null) {
					document.querySelector('textarea[name=VS_COMMENT]').value = invoice.comment;
				}

				document.querySelector('input[name=PARKED_INV_ID]').value = invoice.id;

				// Make the submit button available
				document.querySelector('button[name=create_invoice]').disabled = false;

				document.getElementById('fromParkedInvoice').value = '1';

				const uploadRow = document.getElementById('invoiceFileUpload');
				if(uploadRow) {
				   uploadRow.classList.add('d-none');
				}

				//document.querySelector('input[name=UPLOAD]').style.display = "none";
			} catch (err) {
				console.error('Error. Can\'t copy data from saved parked invoice: ', err);
			}
			validateForm(formId); // trigger the dojo form validation
		}

		if ($scope.parkedInvoices.length === 0) {
			$scope.hasParkedInvoice = false;
		}

		if ($scope.parkedInvoices.length >= 2) {
			$scope.hasParkedInvoice = false;
		}
	};

	/**
	 * Function get id from parked invoice table and id from invoice table.
	 * Data is converting in a storage base on invoice info.
	 * @param id
	 * @param newIndex
	 */
	$scope.convertParkedInvoiceToInvoice = function (id, newIndex) {
		$http({
			method: 'PUT',
			headers: {'Authorization': 'Bearer ' + accessToken},
			url: apiUrl + '/invoice/parked/update/' + id,
			params: {newIndex: newIndex}
		}).then(function (result) {
		}, function (error) {
			switch (error.status) {
				case 404:
					console.error("ERROR. Can't remove parkedInvoice");
					break;
				default:
					console.error(error);
					break;
			}
		});
	};

	/**
	 * !! WARNING: DIRTY !! Validate dijit Form.
	 * Mixing AngularJs and Dojo is not good and should be avoided.
	 * Due to interfering the dojo form in this controller we have to trigger the form validation from here
	 * for usability puroses. We should consider either migrating the 'Lieferscheine' module to Angular/Spring
	 * completely soon.
	 *
	 * @param formId - id of the form to update the validation on
	 */
	function validateForm(formId) {
		var form = dijit.byId(formId);
		form.validate();
	}

};
